// List of keys that potentially contain PII data
const PII_KEYS = [
  'trustLegalName',
  'trustDisplayName',
  'legalName',
  'displayName',
  'accountName',
  'firstName',
  'lastName',
  'fullName',
  'name',
  'creditorName',
  'estateProfileId',
  'householdMemberId',
  'accountId',
  'uuid',
  'ownerUuid',
  'ssn',
  'taxId',
  'balance',
  'amount',
  'valuation',
  'value',
  'address',
  'street',
  'city',
  'state',
  'zipCode',
  'zip',
  'email',
  'phone',
  'phoneNumber',
  'timeZone',
  'locale',
  'ownerData',
  'trustData',
  'accountOwner',
  'response',
  'mezPayload',
  'agoPayload',
  'accountMutation',
];

// Recursively redacts PII from a payload object
// Note: Apps can control redaction by passing shouldRedact flag if needed
export function redactPIIFromPayload(payload: any, shouldRedact: boolean = true): any {

  // Skip redaction if explicitly disabled
  if (!shouldRedact) {
    return payload;
  }

  if (payload === null || typeof payload !== 'object') {
    return payload;
  }

  const redactedPayload: any = {};

  if (Array.isArray(payload)) {
    return payload.map(item => redactPIIFromPayload(item));
  }

  for (const [key, value] of Object.entries(payload)) {
    // Checks if the key is a value that needs to be redacted
    if (PII_KEYS.some(piiKey => key.toLowerCase().includes(piiKey.toLowerCase()))) {
      redactedPayload[key] = '[REDACTED]';
    }
    else {
      // Recursively process non-PII keys
      redactedPayload[key] = redactPIIFromPayload(value);
    }
  }

  return redactedPayload;
}
